import gql from 'graphql-tag';

export default gql`
  mutation(
    $publicationUrl: URI!
    $suggestionsListId: ID!
    $awards: [String!]!
  ) {
    addAwardsSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
        awards: $awards
      }
    ) {
      code
    }
  }
`;
